import type { ReactNode } from 'react';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { queryClient } from '../api/queryClient';
import { queryPersister } from '../offline/persister';
import { AuthProvider } from '../auth/AuthProvider';
import { CurrencyProvider } from '../currency/CurrencyProvider';
import { SyncProvider } from '../sync/SyncProvider';
import { PosProvider } from '../pos/PosProvider';
import { ToastProvider } from '../ui/ToastProvider';
import { useRates } from '../api/queries';

function RatesBridge({ children }: { children: ReactNode }) {
  const { data } = useRates();
  return <CurrencyProvider rates={data ?? []}>{children}</CurrencyProvider>;
}

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: queryPersister,
        maxAge: 24 * 60 * 60 * 1000,
        buster: 'gravenca-v2',
      }}
    >
      <AuthProvider>
        <ToastProvider>
          <RatesBridge>
            <SyncProvider>
              <PosProvider>{children}</PosProvider>
            </SyncProvider>
          </RatesBridge>
        </ToastProvider>
      </AuthProvider>
    </PersistQueryClientProvider>
  );
}
